import CompanySidebar from "../sidebar/CompanySidebar";
const People = () => {
    return(
        <>
            <div style={{
            display:'flex',
            flexDirection:'row'
          }}>
          
          <CompanySidebar/>
          <div style={{
            width:'100%',
            display:'flex',
            justifyContent:'center',
            
            
            
        }}></div>
        </div>

        </>
    )
    
}
export default People;